import React from 'react';

const SplitTestContext = React.createContext({
    calculateProps() {},
    testData: {},
});

export default SplitTestContext;
